<template>
	<div>
		<v-app-bar app color="primary" dark>
			<v-app-bar-nav-icon @click.stop="drawer=!drawer"></v-app-bar-nav-icon>
			<v-toolbar-title class="titulo">
				Registro Ponto
			</v-toolbar-title>
			<v-spacer></v-spacer>
			<UserDropdown v-if="!hideUserDropdown"/>
		</v-app-bar>
		<v-navigation-drawer v-model="drawer" app color="background">
			<div class="sidebar-brand" aria-label="CRG Elétrica e Iluminação">
				<div class="sidebar-logo-viewport">
					<img src="@/img/logoCRG.jpeg" alt="CRG Elétrica e Iluminação" class="sidebar-logo">
				</div>
				<div class="sidebar-brand-line"></div>
			</div>
			<v-list dense class="sidebar-list">
				<v-list-item v-for="(item,i) in items" :key="i">
					<v-list-item :to="item.link" v-if="!item.sublinks" class="sidebar-item">
						<v-list-item-icon>
							<v-icon color="primary" v-text="item.icon"></v-icon>
						</v-list-item-icon>
						<v-list-item-content>
							<v-list-item-title class="sidebar-text" v-text="item.text"></v-list-item-title>
						</v-list-item-content>
					</v-list-item>
					<v-list-group no-action v-else class="sidebar-group">
						<template v-slot:activator>
							<v-list-item-icon>
								<v-icon color="primary" v-text="item.icon"></v-icon>
							</v-list-item-icon>
							<v-list-item-title class="sidebar-text" v-text="item.text"></v-list-item-title>
						</template>
						<v-list-item v-for="sublink in item.sublinks" :key="sublink.text" :to="sublink.link" class="sidebar-subitem">
							<v-list-item-title class="sidebar-subtext" v-text="sublink.text">
							</v-list-item-title>
						</v-list-item>
					</v-list-group>
				</v-list-item>
			</v-list>
		</v-navigation-drawer>
	</div>	
</template>

<script>
import { mapState } from 'vuex'
import UserDropdown from './UserDropdown'
import deviceDetection from '@/mixins/deviceDetection'

export default {

	name: 'TheHeader',
	components: { UserDropdown },
	mixins: [deviceDetection],
	props: {
		titulo: String,
		hideToggle: Boolean,
		hideUserDropdown: Boolean
	},
	data() {
		return {
			meta:0,
			drawer:true,
			items:[]
		}
	},
	watch: {
		isMobile(newVal) {
			this.drawer = !newVal
		},
		user: {
			handler() {
				if (this.user) {
					this.fnLink()
				}
			},
			deep: true
		}
	},
	computed:mapState(['user']),
	methods: {
		normalizeTipo(tipo) {
			return String(tipo || '').trim().toLowerCase()
		},
		isPerfilGestao(user) {
			return ['admin', 'master', 'gerente', 'coordenador', 'financeiro', 'supervisor'].includes(this.normalizeTipo(user?.tipo))
		},
		isTruthy(value) {
			return value === 1 || value === true || value === '1'
		},
		fnLink() {
			const allItems = [
				// { text: 'Indicadores', icon: 'mdi-chart-bar', link: '/', perm: 'indicadores' },
				{ text: 'Meu Ponto', icon: 'mdi-calendar-account', link: '/pontos', perm: null },
				{ text: 'Colaboradores', icon: 'mdi-account-group', link: '/usuarios', perm: 'colaboradores' },
				{ text: 'Carga Horária', icon: 'mdi-account-clock', link: '/carga', perm: 'cargahoraria' },
				{ text: 'Area Reservada', icon: 'mdi-shield-account', link: '/area-reservada', perm: 'areaReservada' },
				{ text: 'Agendamentos', icon: 'mdi-calendar', link: '/agendamentos', perm: 'agendamentos' },
				// { text: 'Solicitações', icon: 'mdi-account-alert', link: '/solicitacoes', perm: 'solicitacoes' },
				{ text: 'Relatorios', icon: 'mdi-file-chart-outline', link: '/relatorios', perm: 'relatorios' }
				];
			if (!this.user) {
				this.items = []
				return
			}
			

			this.items = allItems.filter(item => {
				// Meu Ponto sempre visível
				if (!item.perm) {
					console.log(`${item.text}: sempre visível`)
					return true
				}

				if (item.perm === 'areaReservada') {
					return this.normalizeTipo(this.user.tipo) === 'master' || Number(this.user.idfuncionario || 0) === 14
				}
				
				if (this.isPerfilGestao(this.user)) {
					console.log(`${item.text}: perfil de gestao - permitido`)
					return true
				}
				
				// Verificar permissão: 1 = permitido, 0 ou undefined = não permitido
				const hasPermission = this.isTruthy(this.user[item.perm])
				console.log(`${item.text}: ${this.user[item.perm]} -> ${hasPermission ? 'PERMITIDO' : 'NEGADO'}`)
				return hasPermission
			})
			
			console.log('Menu final:', this.items.map(i => i.text))
		}
	},
	mounted(){
		this.fnLink()
		this.drawer = !this.isMobile
	},

};
</script>

<style lang="css" scoped>
.v-app-bar {
	border-bottom: 3px solid var(--accent-color) !important;
}

.sidebar-brand {
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: 14px 18px 8px;
	background: linear-gradient(180deg, #ffffff 0%, var(--background-color) 100%);
}

.sidebar-logo-viewport {
	width: 100%;
	max-width: 210px;
	height: 118px;
	overflow: hidden;
	display: flex;
	align-items: center;
	justify-content: center;
}

.sidebar-logo {
	display: block;
	width: 205px;
	height: 205px;
	max-width: none;
	object-fit: contain;
	transform: translateY(1px);
}

.sidebar-brand-line {
	width: 72px;
	height: 3px;
	margin-top: 7px;
	border-radius: 999px;
	background: var(--accent-color);
}

.sidebar-list {
	padding-top: 8px;
}

.sidebar-item {
	margin-bottom: 2px;
	border-radius: 4px;
	transition: background-color 0.2s;
}

.sidebar-item:hover {
	background-color: rgba(0, 0, 111, 0.07) !important;
}

.sidebar-item.v-list-item--active {
	background-color: var(--primary-color) !important;
	color: white !important;
	box-shadow: inset 4px 0 0 var(--accent-color);
}

.sidebar-item.v-list-item--active .sidebar-text {
	color: white !important;
}

.sidebar-item.v-list-item--active .v-icon {
	color: white !important;
}

.sidebar-text {
	color: var(--primary-color) !important;
	font-weight: 500;
	font-size: 14px;
}

.sidebar-group .v-list-group__header {
	padding-left: 16px;
}

.sidebar-group .v-list-group__header:hover {
	background-color: rgba(0, 0, 111, 0.07) !important;
}

.sidebar-subitem {
	padding-left: 56px !important;
	margin-bottom: 1px;
}

.sidebar-subitem:hover {
	background-color: rgba(0, 0, 111, 0.07) !important;
}

.sidebar-subtext {
	color: var(--primary-color) !important;
	font-size: 12px;
	font-weight: 400;
}

.sidebar-subitem.v-list-item--active {
	background-color: var(--primary-color) !important;
	box-shadow: inset 4px 0 0 var(--accent-color);
}

.sidebar-subitem.v-list-item--active .sidebar-subtext {
	color: white !important;
}

@media (max-width: 600px) {
	.sidebar-brand {
		padding-top: 10px;
	}

	.sidebar-logo-viewport {
		height: 104px;
		max-width: 190px;
	}

	.sidebar-logo {
		width: 182px;
		height: 182px;
	}
}
</style>
